mutation updateApplicationLive($application_live: Boolean!) {
    updateApplicationLive(application_live: $application_live)
}
